export const serviceCategories = ['food', 'grocery', 'pharmacy', 'parcel', 'other'] as const;
export type ServiceCategory = (typeof serviceCategories)[number];

export const orderStatuses = [
  'submitted',
  'under_review',
  'awaiting_customer_approval',
  'confirmed',
  'assigned',
  'accepted',
  'purchasing_or_collecting',
  'picked_up',
  'on_the_way',
  'delivered',
  'completed',
  'rejected',
  'cancelled',
  'delivery_failed',
] as const;
export type OrderStatus = (typeof orderStatuses)[number];

export const terminalOrderStatuses: ReadonlySet<OrderStatus> = new Set([
  'completed',
  'rejected',
  'cancelled',
  'delivery_failed',
]);

export const activeTrackingStatuses: ReadonlySet<OrderStatus> = new Set([
  'accepted',
  'purchasing_or_collecting',
  'picked_up',
  'on_the_way',
  'delivered',
]);

export const allowedTransitions: Readonly<Record<OrderStatus, readonly OrderStatus[]>> = {
  submitted: ['under_review', 'rejected', 'cancelled'],
  under_review: ['awaiting_customer_approval', 'rejected', 'cancelled'],
  awaiting_customer_approval: ['under_review', 'confirmed', 'cancelled'],
  confirmed: ['assigned', 'cancelled'],
  assigned: ['accepted', 'confirmed', 'cancelled'],
  accepted: ['purchasing_or_collecting', 'picked_up', 'delivery_failed'],
  purchasing_or_collecting: ['picked_up', 'delivery_failed'],
  picked_up: ['on_the_way', 'delivery_failed'],
  on_the_way: ['delivered', 'delivery_failed'],
  delivered: ['completed', 'delivery_failed'],
  completed: [],
  rejected: [],
  cancelled: [],
  delivery_failed: [],
};

export type ActorRole = 'customer' | 'rider' | 'admin' | 'system';

export function canTransition(from: OrderStatus, to: OrderStatus): boolean {
  return allowedTransitions[from].includes(to);
}

export interface MoneyBreakdown {
  estimatedItemCostCentavos: number;
  approvedSpendingLimitCentavos: number;
  deliveryFeeCentavos: number;
  serviceFeeCentavos: number;
}

export function quoteTotalCentavos(value: Pick<MoneyBreakdown, 'estimatedItemCostCentavos' | 'deliveryFeeCentavos' | 'serviceFeeCentavos'>): number {
  return value.estimatedItemCostCentavos + value.deliveryFeeCentavos + value.serviceFeeCentavos;
}

export function formatPhp(centavos: number): string {
  return new Intl.NumberFormat('en-PH', { style: 'currency', currency: 'PHP' }).format(centavos / 100);
}
